const StatBox = ({value, label, trend}) => {
    return (
        <div className="border bg-white rounded flex-fill py-3 px-4">
            <div className="d-flex align-items-center mb-2">
                <span className="fs-1 fw-bold text-gray-800 me-2 lh-1 ls-n2">{value}</span>
                {trend && <span className="badge badge-light-success fs-7 ms-4">{trend}</span>}
            </div>
            <div className="fw-semibold fs-6 text-gray-700">{label}</div>
        </div>
    )
}
export default StatBox